export const LOCATION_VERIFICATION_FILLED = 'LOCATION_VERIFICATION_FILLED'
export const LOCATION_VERIFICATION_STARTED = 'LOCATION_VERIFICATION_STARTED'
export const SKIP_LOCATION_VERIFICATION = 'SKIP_LOCATION_VERIFICATION'
export const LOCATION_VERIFICATION_CLOSED = 'LOCATION_VERIFICATION_CLOSED'
